import { Chip } from '@mui/joy';
import { ProjectStatus, PROJECT_STATUS_LABELS } from '@/types/project';

const STATUS_COLORS: Record<ProjectStatus, 'neutral' | 'primary' | 'success' | 'warning' | 'danger'> = {
  not_started: 'neutral',
  in_progress: 'primary',
  completed: 'success',
  on_hold: 'warning',
  cancelled: 'danger',
};

export default function ProjectStatusChip({ status }: { status: ProjectStatus }) {
  return (
    <Chip size="sm" variant="soft" color={STATUS_COLORS[status]}>
      {PROJECT_STATUS_LABELS[status]}
    </Chip>
  );
}
